import React from "react";
import { useNavigate } from "react-router-dom";
import { removeCookie } from "../config/webStorage";

const Unauthorized = () => {
  const navigate = useNavigate();

  const Handler = () => {
    removeCookie("sctoken");
    navigate("/");
  };

  return (
    <div className="w-full h-screen bg-gray-100 flex flex-col justify-center items-center text-center">
      <img
        src="/Frame1.png"
        alt="Unauthorized Access"
        className="w-48 h-48 mb-6"
      />
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Access Denied</h1>
      <p className="text-gray-600 mb-6">
        You don't have the necessary permissions to view this page.
      </p>
      <button
        onClick={Handler}
        className="bg-blue-500 text-white px-6 py-2 rounded-md shadow hover:bg-blue-600 transition"
      >
        Go to Login
      </button>
    </div>
  );
};

export default Unauthorized;
